export default __webpack_public_path__ + "static/media/filter-svg.bc2c9681.svg";